const list = {
    searchList:[
        {
            "entityField": "start",
            "chineseField": "开始时间",
            "showField": "开始时间",
            "isShow": 1,
            "isRequired": 0,
            "isChange": 1,
            "fieldType": "date",
            "formatterContent": null,
            "searchId": null,
            "extractId": null,
            "isReserved": 0,
            "sort": 1,
            "fieldWeight": 100,
            "isRift": 0,
            "riftField": null,
            "isCustomize": null,
            "focusField": null,
            "setField": null,
        },
        {
            "entityField": "end",
            "chineseField": "结束时间",
            "showField": "结束时间",
            "isShow": 1,
            "isRequired": 0,
            "isChange": 1,
            "fieldType": "date",
            "formatterContent": null,
            "searchId": null,
            "extractId": null,
            "isReserved": 0,
            "sort": 1,
            "fieldWeight": 100,
            "isRift": 0,
            "riftField": null,
            "isCustomize": null,
            "focusField": null,
            "setField": null,
        },
        {
            "entityField": "bgmName",
            "chineseField": "通用名称",
            "showField": "通用名称",
            "isShow": 1,
            "isRequired": 0,
            "isChange": 1,
            "fieldType": "search",
            "formatterContent": null,
            "searchId": 853533363572736,
            "extractId": null,
            "isReserved": 0,
            "sort": 1,
            "fieldWeight": 100,
            "isRift": 0,
            "riftField": null,
            "isCustomize": null,
            "focusField": null,
            "setField": "bgmName,bgmId",
        },
        {
            "entityField": "manufacturer",
            "chineseField": "生产厂商",
            "showField": "生产厂商",
            "isShow": 1,
            "isRequired": 0,
            "isChange": 1,
            "fieldType": "string",
            "formatterContent": null,
            "searchId": null,
            "extractId": null,
            "isReserved": 0,
            "sort": 1,
            "fieldWeight": 100,
            "isRift": 0,
            "riftField": null,
            "isCustomize": null,
            "focusField": null,
            "setField": null,
        },
    ],
    tableList:[
        {
            "entityField": "bgmCode",
            "showField": "商品编码",
            "isShow": 1,
            "fieldType": "string",
            "formatterContent": null,
            "fieldSort": 2,
            "fieldWeight": 120,
            "isRift": 0,
            "riftField": null,
            "isCustomize": null,
            "isSort": 0
        },
        {
            "entityField": "bgmName",
            "showField": "通用名称",
            "isShow": 1,
            "fieldType": "string",
            "formatterContent": null,
            "fieldSort": 1,
            "fieldWeight": 160,
            "isRift": 0,
            "riftField": null,
            "isCustomize": null,
            "isSort": 0
        },
        {
            "entityField": "bgpUnitmeasurement",
            "showField": "包装单位",
            "isShow": 1,
            "fieldType": "string",
            "formatterContent": null,
            "fieldSort": 2,
            "fieldWeight": 100,
            "isRift": 0,
            "riftField": null,
            "isCustomize": null,
            "isSort": 0
        },
        {
            "entityField": "fileNumber",
            "showField": "批准文号",
            "isShow": 1,
            "fieldType": "string",
            "formatterContent": null,
            "fieldSort": 2,
            "fieldWeight": 120,
            "isRift": 0,
            "riftField": null,
            "isCustomize": null,
            "isSort": 0
        },
        {
            "entityField": "manufacturer",
            "showField": "生产厂商",
            "isShow": 1,
            "fieldType": "string",
            "formatterContent": null,
            "fieldSort": 2,
            "fieldWeight": 160,
            "isRift": 0,
            "riftField": null,
            "isCustomize": null,
            "isSort": 0
        },
        {
            "entityField": "packingSpec",
            "showField": "装箱规格",
            "isShow": 1,
            "fieldType": "string",
            "formatterContent": null,
            "fieldSort": 2,
            "fieldWeight": 120,
            "isRift": 0,
            "riftField": null,
            "isCustomize": null,
            "isSort": 0
        },
        {
            "entityField": "placeorigin",
            "showField": "产地",
            "isShow": 1,
            "fieldType": "string",
            "formatterContent": null,
            "fieldSort": 2,
            "fieldWeight": 100,
            "isRift": 0,
            "riftField": null,
            "isCustomize": null,
            "isSort": 0
        },
        {
            "entityField": "spec",
            "showField": "规格",
            "isShow": 1,
            "fieldType": "string",
            "formatterContent": null,
            "fieldSort": 2,
            "fieldWeight": 160,
            "isRift": 0,
            "riftField": null,
            "isCustomize": null,
            "isSort": 0
        },
    ],
    buttonList:[
        {
            actionType: 0,
            jurName:"新增",
            jurSort:0,
        },
        // {
        //     actionType: 1,
        //     jurName:"编辑",
        //     jurSort:1,
        // },
        {
            actionType: 2,
            jurName:"删除",
            jurSort:2,
        },
    ],
    formList:[
        {
            "entityField": "bgmName",
            "showField": "通用名称",
            "isShow": 1,
            "isChange": 1,
            "fieldType": "search",
            "formatterContent": null,
            "searchId": 853533363572736,
            "isReserved": 0,
            "sort": 1,
            "fieldWeight": 250,
            "isRift": 1,
            "riftField": "bgmId",
            "focusField": "woadPnumber",
            "setField": "bgmName,bgmId",
            "defaultValue": "",
        },
        // {
        //     "entityField": "bgiGename",
        //     "showField": "商品名称",
        //     "isShow": 1,
        //     "fieldType": "string",
        //     "fieldWeight": 160,
        // },
        {
            "entityField": "spec",
            "showField": "规格",
            "isShow": 1,
            "fieldType": "string",
            "fieldWeight": 160,
        },
        // {
        //     "entityField": "bgpSituation",
        //     "showField": "包装规格",
        //     "isShow": 1,
        //     "fieldType": "string",
        //     "fieldWeight": 100,
        // },
        {
            "entityField": "manufacturer",
            "showField": "生产厂商",
            "isShow": 1,
            "fieldType": "string",
            "fieldWeight": 120,
        },
        {
            "entityField": "placeorigin",
            "showField": "产地",
            "isShow": 1,
            "fieldType": "string",
            "fieldWeight": 120,
        },
        {
            "entityField": "bgpUnitmeasurement",
            "showField": "包装单位",
            "isShow": 1,
            "fieldType": "string",
            "fieldWeight": 120,
        },
        {
            "entityField": "fileNumber",
            "showField": "档案编号",
            "isShow": 1,
            "fieldType": "string",
            "fieldWeight": 120,
        },
    ],
}
export default list;